import { createHOC } from 'vue-hoc';

import LoginForm from './LoginForm';
import auth from '~lib/common/providers/auth';
import getSafeRedirectUrl from '~lib/common/utils/getSafeRedirectUrl';

const redirectToRequestedUrl = (redirectUrl) => {
  if (!redirectUrl) return false;
  window.location.replace(redirectUrl);
  return true;
};

const options = {
  name: 'LoginFormContainer',
  data() {
    return {
      state: {
        loading: false,
        error: null,
      },
    };
  },
  async created() {
    const { query } = this.$route;
    if (await auth.isAuthenticated()) {
      if (redirectToRequestedUrl(query.redirectUrl)) {
        return;
      }
      this.$router.push({ name: 'verifyEmail' });
    }
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
  },
  listeners: {
    async login(email, password) {
      this.state.error = null;
      this.state.loading = true;
      const { query } = this.$route;
      try {
        // short circuit for missing password
        if (!password || !password.length) {
          throw new Error('Must specify a password.');
        }
        const options = {
          email,
          password,
        };
        if (query.redirectUrl) {
          const safeRedirectUrl = getSafeRedirectUrl(query.redirectUrl);
          if (safeRedirectUrl) {
            const callbackUrl = new URL('/auth/callback', window.location.origin);
            callbackUrl.searchParams.set('updated', Date.now().toString());
            callbackUrl.searchParams.set('redirectUrl', safeRedirectUrl);
            options.redirectUri = callbackUrl.toString();
          }
        }
        await auth.login(options);
      } catch (error) {
        console.error(error);
        this.state.error = {
          ...error,
          message: error.message || error.description,
        };
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const LoginFormContainer = createHOC(LoginForm, options, renderWith);
export default LoginFormContainer;
